window.get_discount = '';
window.appliedProductDiscount = null;

async function fetchCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`Cart failed: ${response.status}`);
    return await response.json();
  } catch (err) {
    console.error('Cart.js error:', err);
    return null;
  }
}

async function fetchDiscount(discountCode) {
  try {
    const response = await fetch(
      'https://integrations.playermaker.co.uk/webhook/pm-discount-data-v2',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: discountCode }),
      }
    );
    return await response.json();
  } catch (err) {
    console.error('Discount webhook error:', err);
    return null;
  }
}

function formatMoneyWithoutCents(cents) {
  return Shopify.formatMoney(cents, window.Money_Filter)
    .replace(',00', '')
    .replace('.00', '');
}

function getProductPriceElements() {
  return document.querySelectorAll('.price_main_product, .price_main_product_discount');
}

function normalizePercentage(value) {
  const pct = parseFloat(value);
  if (isNaN(pct)) return null;
  return pct > 1 ? pct / 100 : pct;
}

function parseDiscountFromResponse(response) {
  const value = response?.discount?.[0]?.discount?.customerGets?.value;
  if (!value) return null;

  if (value.percentage != null && value.percentage !== '') {
    const normalized = normalizePercentage(value.percentage);
    if (normalized == null) return null;
    return { type: 'percentage', value: normalized };
  }

  const amount = value?.amount?.amount;
  if (amount != null && parseFloat(amount) > 0) {
    return { type: 'fixed', value: parseFloat(amount) };
  }

  return null;
}

function getQuantityMultiplier() {
  const qtyInput = document.querySelector('.total_price .quantity__input, .first-step .quantity__input');
  const qty = parseInt(qtyInput?.value, 10);
  return qty > 0 ? qty : 1;
}

function showDiscountBadges() {
  document.querySelectorAll('.first-step-total-price-discount').forEach((el) => {
    el.classList.add('flex-discount');
  });
  document.querySelectorAll('.compare-price[data-compare-price]').forEach((compareEl) => {
    const compareAtCents = Math.round(parseFloat(compareEl.dataset.comparePrice) || 0);
    if (!compareAtCents) return;
    const priceWrap = compareEl.closest('.cart_discount_main');
    if (priceWrap) {
      priceWrap.classList.add('flex-discount', 'has-compare-at');
    }
  });
  document.body.classList.add('has-discount-code');
}

function updateStickyButtonDiscounts(text) {
  document.querySelectorAll('.sticky-add-to-cart-btn .select-membership-cart-discount').forEach((el) => {
    el.innerHTML = text;
    el.style.display = '';
  });
}

function updateOtherButtonDiscounts(text) {
  document.querySelectorAll('.select-membership-cart-discount').forEach((el) => {
    if (!el.closest('.sticky-add-to-cart-btn') && !el.closest('cart-drawer')) {
      el.innerHTML = text;
      el.style.display = '';
    }
  });
}

function updateDiscountBadgeValues(value, isPercentage) {
  document.querySelectorAll('.select-membership-cart-discount-main .discount_value').forEach((discountEl) => {
    discountEl.innerHTML = isPercentage ? `${value}%` : value;
  });
}

function updateComparePrices(quantity, selector = '.compare-price', variantUnitCents = 0) {
  const qty = quantity > 0 ? quantity : 1;
  const usePreCodeVariantPrice = Boolean(window.appliedProductDiscount && variantUnitCents > 0);

  document.querySelectorAll(selector).forEach((compareEl) => {
    const compareAtCents = Math.round(parseFloat(compareEl.dataset.comparePrice) || 0);
    const priceWrap = compareEl.closest('.cart_discount_main');

    if (usePreCodeVariantPrice) {
      compareEl.innerHTML = formatMoneyWithoutCents(variantUnitCents * qty);
      if (priceWrap) {
        priceWrap.classList.add('flex-discount', 'has-compare-at');
      }
      return;
    }

    if (!compareAtCents) return;
    compareEl.innerHTML = formatMoneyWithoutCents(compareAtCents * qty);
  });
}

function setPriceElementDiscountMeta(priceEl, discount) {
  if (discount.type === 'percentage') {
    const percentLabel = Math.round(discount.value * 100);
    priceEl.setAttribute('data-percentage', 'percentage');
    priceEl.setAttribute('data-discount', String(percentLabel));
  } else {
    priceEl.removeAttribute('data-percentage');
    priceEl.setAttribute('data-discount', String(Math.round(discount.value)));
  }
}

function calculateDiscountedUnitCents(originalCents, discount) {
  if (discount.type === 'percentage') {
    const discountCents = Math.round(originalCents * discount.value);
    const finalCents = Math.max(0, originalCents - discountCents);
    return Math.round(finalCents / 100) * 100;
  }

  const rate = Shopify?.currency?.rate || 1;
  const discountCents = Math.round(parseFloat(discount.value) * 100 * rate);
  const finalCents = Math.max(0, originalCents - discountCents);
  return Math.round(finalCents / 100) * 100;
}

function cityplayPage() {
  if (document.body.classList.contains('cityplay-product-page')) return true;
  for (const className of document.body.classList) {
    if (className.includes('cityplay')) return true;
  }
  return false;
}

function cityplayPriceElements() {
  return document.querySelectorAll(
    '.total_price .price_main_product, .price_warp .price_main_product, .sticky-container .price_main_product'
  );
}

function refreshProductDiscountPrices(quantity) {
  const discount = window.appliedProductDiscount;
  if (!discount) return;

  const qty = quantity || getQuantityMultiplier();
  const priceEls = cityplayPage() ? cityplayPriceElements() : getProductPriceElements();

  let variantUnitCents = 0;

  priceEls.forEach((priceEl) => {
    const originalCents = Math.round(parseFloat(priceEl.dataset.price) || 0);
    if (!originalCents) return;

    variantUnitCents = originalCents;
    setPriceElementDiscountMeta(priceEl, discount);
    const unitCents = calculateDiscountedUnitCents(originalCents, discount);
    priceEl.innerHTML = formatMoneyWithoutCents(unitCents * qty);
  });

  const mainPriceEl = document.querySelector('.total_price .price_main_product');
  if (!mainPriceEl) return;

  const originalCents = Math.round(parseFloat(mainPriceEl.dataset.price) || 0);
  if (!originalCents) return;

  variantUnitCents = originalCents;

  const compareSelector = cityplayPage()
    ? '.total_price .compare-price, .price_warp .compare-price, .sticky-container .compare-price'
    : '.compare-price';
  updateComparePrices(qty, compareSelector, variantUnitCents);
}

function applyFixedDiscountToPrices(discountAmount) {
  window.appliedProductDiscount = { type: 'fixed', value: parseFloat(discountAmount) };
  refreshProductDiscountPrices(getQuantityMultiplier());

  const rate = Shopify?.currency?.rate || 1;
  const convertedDiscountCents = Math.round(parseFloat(discountAmount) * 100 * rate);
  return Math.round(convertedDiscountCents / 100) * 100;
}

function applyPercentageDiscountToPrices(discountPercentage) {
  window.appliedProductDiscount = { type: 'percentage', value: discountPercentage };
  refreshProductDiscountPrices(getQuantityMultiplier());
  return Math.round(discountPercentage * 100);
}

function applyDiscountUI(discount) {
  showDiscountBadges();

  if (discount.type === 'fixed') {
    const roundedDiscountCents = applyFixedDiscountToPrices(discount.value);
    window.get_discount = roundedDiscountCents;

    const formattedDiscount = formatMoneyWithoutCents(roundedDiscountCents);
    const label = `${formattedDiscount} OFF`;
    updateDiscountBadgeValues(formattedDiscount, false);
    updateStickyButtonDiscounts(label);
    updateOtherButtonDiscounts(label);
    return;
  }

  const percentLabel = applyPercentageDiscountToPrices(discount.value);
  window.get_discount = `${percentLabel}%`;
  const label = `${percentLabel}% OFF`;

  updateDiscountBadgeValues(percentLabel, true);
  updateStickyButtonDiscounts(label);
  updateOtherButtonDiscounts(label);
}

async function initProductDiscountFromCart() {
  try {
    const cartData = await fetchCart();
    if (!cartData) return;

    const discountObj = cartData.discount_codes?.[0];
    if (!discountObj) return;

    const response = await fetchDiscount(discountObj.code);
    const discount = parseDiscountFromResponse(response);
    if (!discount) return;

    applyDiscountUI(discount);
  } catch (err) {
    console.error('Page error:', err);
  }
}

window.refreshProductDiscountPrices = refreshProductDiscountPrices;
window.applyDiscountUI = applyDiscountUI;

document.addEventListener('DOMContentLoaded', initProductDiscountFromCart);

document.addEventListener('DOMContentLoaded', () => {
  if (!cityplayPage() || window.appliedProductDiscount) return;
  const qtyInput = document.querySelector('.first-step .quantity__input');
  const qty = parseInt(qtyInput?.value, 10) || 1;
  if (qty > 1 && typeof window.renderCityplayProductPrices === 'function') {
    window.renderCityplayProductPrices(qty);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function') return;

  subscribe('quantity-update', () => {
    if (!window.appliedProductDiscount) return;
    refreshProductDiscountPrices(getQuantityMultiplier());
  });
});

window.addEventListener('load', () => {
  if (!window.appliedProductDiscount) return;
  refreshProductDiscountPrices(getQuantityMultiplier());
});
